declare namespace $ {

	type $mol_text__text_shm_tests_visual_1 = $mol_type_enforce<
		ReturnType< $shm_tests_visual['comparison_title'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_text__text_shm_tests_visual_2 = $mol_type_enforce<
		ReturnType< $shm_tests_visual['comparison_status'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_view__sub_shm_tests_visual_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_text__text_shm_tests_visual_4 = $mol_type_enforce<
		ReturnType< $shm_tests_visual['comparison_metrics'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_view__sub_shm_tests_visual_5 = $mol_type_enforce<
		ReturnType< $shm_tests_visual['image_rows'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_text__text_shm_tests_visual_6 = $mol_type_enforce<
		ReturnType< $shm_tests_visual['image_title'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_image__uri_shm_tests_visual_7 = $mol_type_enforce<
		ReturnType< $shm_tests_visual['image_uri'] >
		,
		ReturnType< $mol_image['uri'] >
	>
	type $mol_image__title_shm_tests_visual_8 = $mol_type_enforce<
		ReturnType< $shm_tests_visual['image_title'] >
		,
		ReturnType< $mol_image['title'] >
	>
	type $mol_link__uri_shm_tests_visual_9 = $mol_type_enforce<
		ReturnType< $shm_tests_visual['image_uri'] >
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__external_shm_tests_visual_10 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_link['external'] >
	>
	type $mol_link__sub_shm_tests_visual_11 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	export class $shm_tests_visual extends $mol_view {
		comparison_title( ): string
		Title( ): $mol_text
		comparison_status( ): string
		Status( ): $mol_text
		Head( ): $mol_view
		comparison_metrics( ): string
		Metrics( ): $mol_text
		image_rows( ): readonly($mol_view)[]
		Images( ): $mol_view
		image_uri( id: any): string
		image_title( id: any): string
		Image_label( id: any): $mol_text
		Picture( id: any): $mol_image
		comparison( ): any
		manifest_uri( ): string
		sub( ): readonly(any)[]
		Image( id: any): $mol_link
	}
	
}

//# sourceMappingURL=visual.view.tree.d.ts.map